import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { LivretEval } from '../types/livret';
import livretKeys from './keys';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

interface Props {
  livretEvalId: string;
}

function deleteLivretEleve({
  schoolyearId,
  schoolId,
  livretEleveId,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEleveId: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets-eleves/${livretEleveId}`;
  return request(requestURL, {
    method: 'DELETE',
  });
}

export function useDeleteLivretEleve(props: Props) {
  const { notifyError } = useNotification();
  const { livretEvalId } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['carnet']);
  const { mutateAsync } = useMutation({
    mutationFn: (livretEleveId: string) =>
      deleteLivretEleve({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEleveId,
      }),
    onMutate: livretEleveId => {
      queryClient.setQueryData<LivretEval>(
        livretKeys.livretDetail(schoolyear.id, school.id, livretEvalId),
        (oldLivretEval: LivretEval) => ({
          ...oldLivretEval,
          livretsEleves: (oldLivretEval || []).livretsEleves.filter(
            livretEleve => livretEleve.id !== livretEleveId,
          ),
        }),
      );
    },
    onError: () => {
      queryClient.invalidateQueries({
        queryKey: livretKeys.livretDetail(
          schoolyear.id,
          school.id,
          livretEvalId,
        ),
      });
      notifyError({
        title: t('carnet:messages.livret.deleteError'),
      });
    },
  });
  return mutateAsync;
}
